import bodyClasses from './body-classes';
import $ from 'jquery';

$(_ => {

    const $body = $(document.body);
    const menus = [
        {
            btn: '.js-btn-buy-tix-toggle',
            menu: '#buy-tix-popout',
            bodyClasses: bodyClasses.buyTix,
            isOpen: false,
            autoOpenHeight: true
        },
        {
            btn: '#btn-nav-main',
            menu: '#nav-main',
            bodyClasses: bodyClasses.navMain,
            isOpen: false,
            autoOpenHeight: true
        }
    ];

    for (const config of menus) {

        const $menu = $(config.menu);
        const $btn = $(config.btn);

        const $contents = $menu.children('.js-mobile-menu-contents');

        $menu.on('transitionend', event => {
            if (event.target !== $menu[0]) return;

            window.requestAnimationFrame(_ => {
                if (config.isOpen) {
                    if (config.autoOpenHeight) {
                        $menu.height('auto');
                    }
                } else {
                    $body.removeClass(config.bodyClasses.closing);
                }
            });
        });
        $btn.on('click', event => {
            event.preventDefault();

            if (config.isOpen) {
                const height = $menu.outerHeight();
                window.requestAnimationFrame(_ => {
                    $body.removeClass(config.bodyClasses.open);
                    $body.addClass(config.bodyClasses.closing);
                    $menu.height(height);
                    window.requestAnimationFrame(_ => {
                        $menu.height(0);
                    });
                });
            } else {

                const height = $contents.outerHeight();

                window.requestAnimationFrame(_ => {
                    $body.addClass(config.bodyClasses.open);
                    $menu.height(height);
                });
            }

            config.isOpen = !config.isOpen;
        });
    }
});